import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/icon/logo-twitter.png'
import _imports_1 from '../../images/icon/logo-alibaba.png'
import _imports_2 from '../../images/icon/logo-youtube.png'
import _imports_3 from '../../images/icon/logo-facebook.png'


const _withScopeId = n => (_pushScopeId("data-v-54837844"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-detail" }
const _hoisted_2 = {
  key: 0,
  class: "loading",
  "element-loading-background": "rgba(255, 255, 255, 0.6)"
}
const _hoisted_3 = { class: "detail-top" }
const _hoisted_4 = { class: "top" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "top-content" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Benefits:", -1))
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Lead Time:", -1))
const _hoisted_14 = { class: "value" }
const _hoisted_15 = {
  border: "1",
  style: {"border":"1px solid rgba(151, 151, 151, 0.3)"}
}
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Shipping:", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "down" }
const _hoisted_20 = { class: "imgs" }
const _hoisted_21 = { class: "right" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-bt" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://www.otimes.com//front/fileMonitor.dbys?filePath=/group1/M00/02/9D/cjez0GQT4ImAZ9rsAAADKN29FNI702.png",
    alt: "Product Inquiry"
  }),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "#contact" }, " Product Inquiry")
  ])
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.otimes.com//front/fileMonitor.dbys?filePath=/group1/M00/02/9D/cjez0GQT4I2AeD61AAAC0NbpCAs000.png",
  alt: "Basket"
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Add to Basket", -1))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "detail" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Product Details"),
  /*#__PURE__*/_createElementVNode("div", { class: "line" })
], -1))
const _hoisted_28 = {
  class: "quick-details",
  style: {"margin-bottom":"40px"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Quick Details", -1))
const _hoisted_30 = { class: "content" }
const _hoisted_31 = {
  class: "delivery-details",
  style: {"margin-bottom":"40px"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Packaging & Delivery", -1))
const _hoisted_33 = { class: "content" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 1,
  class: "imgs",
  style: {"display":"flex"}
}
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = {
  class: "contact",
  id: "contact"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Contact Details"),
  /*#__PURE__*/_createElementVNode("div", { class: "line" })
], -1))
const _hoisted_39 = { class: "content" }
const _hoisted_40 = { class: "left" }
const _hoisted_41 = /*#__PURE__*/_createStaticVNode("<div class=\"top\" data-v-54837844>Eighth Element Environment Technology Co., Ltd.</div><p data-v-54837844><span class=\"label\" data-v-54837844>Contact Person :</span><span class=\"value\" data-v-54837844> Shiqing Gong </span></p><p data-v-54837844><span class=\"label\" data-v-54837844>Tel:</span><span class=\"value\" data-v-54837844> 0755-8322 7395 </span></p>", 3)
const _hoisted_44 = { class: "logo-link" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "OTIMES twitter"
}, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "OTIMES alibaba"
}, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "OTIMES youtube"
}, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "OTIMES facebook"
}, null, -1))
const _hoisted_49 = { class: "right" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top" }, "Send your inquiry directly to us", -1))
const _hoisted_51 = {
  class: "left-bt",
  style: {"margin-top":"16px"}
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://www.otimes.com//front/fileMonitor.dbys?filePath=/group1/M00/02/9D/cjez0GQT4ImAZ9rsAAADKN29FNI702.png",
  alt: "Product Inquiry"
}, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Product Inquiry", -1))
const _hoisted_54 = { class: "other" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "detail-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Other product"),
  /*#__PURE__*/_createElementVNode("div", { class: "line" })
], -1))
const _hoisted_56 = { class: "content" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["src", "alt"]
const _hoisted_59 = { class: "text" }

import { usePinia } from '@/store';
import { ElMessage } from 'element-plus';
import { storeToRefs } from 'pinia';
import { computed, onMounted, onUpdated, ref, watch } from 'vue';
import { getDetail, getRecommendList } from '@/api/contact'
import { useRoute, useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const store = usePinia()
const { menuName, scrollY, active, shopList, showShop } = storeToRefs(store) as any
const html = computed(() => {
  return detail.value.productDescriptionText;
})

const router = useRouter()
//去往=详情
const toDetail = ele => {
  menuName.value = ele.category
  detail.value = ele
  // scrollY.value = window.scrollY
  router.push({
    name: 'similar-detail',
    query: {
      id: ele.id,
      category: ele.category,
      essentialDetailsKey: ele.essentialDetailsKey
    }
  })
}

const text = ref('')
const url = ref('')
const getUrl = () => {
  url.value = `https://wa.me/8615070949098?text=${text.value}`
}

//推荐列表
const activeObj = {
  'PLASTICS MATERIAL': 0,
  'STEELS MATERIAL': 1
}
const recommendList = ref([])
const getRecommendListAsync = async () => {
  const res = await getRecommendList({ group: activeObj[active.value], page: 1, size: 6 }) as any
  if (res) {
    recommendList.value = res.data.data.map(v => {
      v.img = v.allImg.split(',')[1]
      return v
    }
    )
  } else {
    ElMessage.error(res.message)
  }
}
getRecommendListAsync()


//添加到购物车
const add = ele => {
  const active = shopList.value.find(v => v.id === ele.id)
  if (active) {
    ElMessage.warning('Product already exists...')
  } else {
    shopList.value.push(ele)
    showShop.value = true
  }
}

const formate = (list) => {
  var datasLen = list.length;
  var datasN = datasLen / parseInt(detail.value.leadTimeTrC);
  var datasLineNum = datasLen % datasN === 0 ? datasLen / datasN : Math.floor((datasLen / datasN) + 1);
  var rain_data = [];
  for (var i = 0; i < datasLineNum; i++) {
    var temp = list.slice(i * datasN, i * datasN + datasN);
    rain_data.push(temp);
  }
  return rain_data
}

//加载出富文本里的图片
const setImgSrc = () => {
  const imgs = document.querySelectorAll('img')
  imgs.forEach(img => {
    if (img.dataset?.src) {
      img.src = img.dataset.src
    }
  })
}

const deliveryImgs = ref([])
const isImg = item => {
  const reg = /\.(?:jpg|jpeg|png|gif)\b/i;
  if (reg.test(item)) {
    deliveryImgs.value = item.split(',')
    return true
  } else {
    return false
  }
}

const detail: any = ref({})
const imgs = ref([])
const tableData = ref([])
const splitImg = ref('')
const quickDetails = ref([])
const delivery = ref([])
const loading = ref(false)
const getDetailAsync = async () => {
  loading.value = true
  const res = await getDetail({ id: route.query.id }) as any
  if (res.code === 200) {
    detail.value = res.data[0]
    quickDetails.value = detail.value.essentialDetailsValue.split('，')
    imgs.value = detail.value.allImg.split(',').slice(0, 5);
    tableData.value = formate(detail.value.leadTime.split('，'))
    splitImg.value = detail.value.allImg.split(',')
    delivery.value = detail.value.packagingDelivery.split('，')
    delivery.value.push(detail.value.packagingDeliveryImg)
    delivery.value = delivery.value.filter(v => v)
  } else {
    ElMessage.error('get detail error !')
  }
  loading.value = false
}

watch(() => route.query.id, (n, o) => {
  if (n) {
    getDetailAsync()
  }
}, { immediate: true })

onUpdated(() => {
  setImgSrc()
}),

  onMounted(() => {
    setImgSrc()
  })

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, null, 512)), [
          [_directive_loading, loading.value]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (detail.value.productVideo)
          ? (_openBlock(), _createElementBlock("video", {
              key: 0,
              src: detail.value.productVideo,
              controls: ""
            }, null, 8, _hoisted_5))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: splitImg.value,
              alt: detail.value.title
            }, null, 8, _hoisted_6)),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(detail.value.title), 1),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(detail.value.benefit), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("table", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (tr, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tr, (td, j) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: j,
                        style: {"padding":"14px 10px"}
                      }, _toDisplayString(td), 1))
                    }), 128))
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, _toDisplayString(detail.value.shipping), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgs.value, (url) => {
            return (_openBlock(), _createBlock(_component_el_image, {
              "preview-teleported": "",
              "preview-src-list": imgs.value,
              src: url,
              alt: "",
              key: url
            }, null, 8, ["preview-src-list", "src"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", {
            class: "right-bt",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (add(detail.value)))
          }, _hoisted_25)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quickDetails.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: item
            }, _toDisplayString(item), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _createElementVNode("div", _hoisted_33, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(delivery.value, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item",
              key: item
            }, [
              (!isImg(item))
                ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(item), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deliveryImgs.value, (url) => {
                      return (_openBlock(), _createBlock(_component_el_image, {
                        key: url,
                        src: url,
                        "preview-src-list": deliveryImgs.value,
                        "preview-teleported": "",
                        style: {"width":"40px","height":"40px","margin-right":"10px"}
                      }, null, 8, ["src", "preview-src-list"]))
                    }), 128))
                  ]))
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", {
        class: "content",
        innerHTML: _unref(html)
      }, null, 8, _hoisted_36)
    ]),
    _createElementVNode("div", _hoisted_37, [
      _hoisted_38,
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createElementVNode("div", _hoisted_44, [
            _createVNode(_component_el_link, {
              underline: false,
              href: "https://twitter.com/Otimes11",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _hoisted_45
              ]),
              _: 1
            }),
            _createVNode(_component_el_link, {
              underline: false,
              href: "https://otimes.en.alibaba.com",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _hoisted_46
              ]),
              _: 1
            }),
            _createVNode(_component_el_link, {
              underline: false,
              href: "https://www.youtube.com/channel/UC6yK4X18rd0h1xKDhkYs8-w",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _hoisted_47
              ]),
              _: 1
            }),
            _createVNode(_component_el_link, {
              underline: false,
              href: "https://www.facebook.com/Eighth-Element-Environment-Technology-Co-Ltd-100322925983089",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _hoisted_48
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _hoisted_50,
          _createVNode(_component_el_input, {
            modelValue: text.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((text).value = $event)),
            autosize: { minRows: 8, maxRows: 8 },
            type: "textarea"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            _createVNode(_component_el_link, {
              href: url.value,
              underline: false,
              target: "_blank",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (getUrl()))
            }, {
              default: _withCtx(() => [
                _hoisted_53
              ]),
              _: 1
            }, 8, ["href"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _hoisted_55,
      _createElementVNode("div", _hoisted_56, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recommendList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "other-item",
            key: item.title,
            onClick: ($event: any) => (toDetail(item))
          }, [
            _createElementVNode("img", {
              src: item.img,
              alt: item.title
            }, null, 8, _hoisted_58),
            _createElementVNode("div", _hoisted_59, _toDisplayString(item.title), 1)
          ], 8, _hoisted_57))
        }), 128))
      ])
    ])
  ]))
}
}

})